module.exports = __webpack_public_path__ + "24941d0d98e04612b8e533773ad717c3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/Goldencity-voll.jpg
// module id = 649
// module chunks = 0